import { Pipe, PipeTransform } from "@angular/core";
import { GlobalDataService } from "../services/globalData.service";
import * as moment from 'moment';


@Pipe({
  name: "ConvertToLocalTime",
  pure: true, // Set to false if the timezone can change dynamically
})
export class ConvertToLocalTimePipe implements PipeTransform {
  constructor(private globalDataService: GlobalDataService) {}

  transform(value: string | Date): string {
    if (!value) return "";

    let utcDate: Date;

    // Ensure the value is parsed as UTC and does not auto-convert to local time
    if (typeof value === "string") {
      // ✅ Check if 'Z' is missing, then append it
      if (!value.toUpperCase().endsWith("Z")) {
        value += "Z"; // Ensures it's treated as UTC
      }

      utcDate = new Date(value); // ✅ 'Z' ensures this is already in UTC
    } else {
      utcDate = new Date(
        Date.UTC(
          value.getFullYear(),
          value.getMonth(),
          value.getDate(),
          value.getHours(),
          value.getMinutes(),
          value.getSeconds()
        )
      ); // ✅ Prevents JavaScript from applying the system timezone
    }

    const timezoneOffset = this.globalDataService.getTimeZoneOffset(); // Get "+05:00" from token

    // Convert "+05:00" to minutes
    const parsedOffset = this.parseTimezoneOffset(timezoneOffset);
    if (isNaN(parsedOffset)) return "Invalid Date";

    // ✅ Ensure proper timezone conversion without double application
    const localDate = new Date(utcDate.getTime() + parsedOffset * 60000);

    return localDate.toLocaleString("en-US", { timeZone: "UTC" }); // ✅ Forces UTC interpretation
  }

  private parseTimezoneOffset(offset: string): number {
    const match = offset.match(/^([+-])(\d{2}):(\d{2})$/);
    if (!match) return NaN;

    const sign = match[1] === "+" ? 1 : -1;
    const hours = parseInt(match[2], 10);
    const minutes = parseInt(match[3], 10);

    return sign * (hours * 60 + minutes);
  }


  ConvertUTCDateLocalDateTime(date: any){
    let convertInToUTC = new Date(date).toISOString();
    const convertInToLocalTime = new Date(this.transform(convertInToUTC));

    // "+5:00"
    // const convertInToLocalTime = '2022-22-11T11:00:00';//new Date(this.transform(convertInToUTC));

    //const convertInToLocalTime = new Date(moment(date).local().format('YYYY-MM-DDTHH:mm:ss'));

    return convertInToLocalTime;
  }
}
